window.addEventListener("hoContentLoaded", () => {
	Vue.component('accordion-item', {
		data: function () {
			return {
				active:false
			}
		},
		computed: {
			prefersReducedMotion()
			{
				return store.getters['settings/prefersReducedMotion'];
			},
		},

		methods: {
			key(event)
			{
				const key = event.which.toString();

				if (key.match(/38|40/) || (key.match(/33|34/)))
				{
					event.preventDefault();

					var direction = (key.match(/34|40/)) ? 1 : -1;

					if(direction > 0)
						this.$parent.next(this);
					else
						this.$parent.prev(this);
				}
			},

			toggle()
			{
				if(!this.active)
				{
					this.open(true);
				}
				else
				{
					this.close();
				}
			},

			focus()
			{
				this.$refs.head.focus();
			},

			open (tween) {
				this.active = true;

				TweenLite.killTweensOf(this.$refs.body);
				TweenLite.set(this.$refs.body,{display:"block"});

				tween = !this.prefersReducedMotion;

				if(tween)
				{
					TweenLite.to(this.$refs.body,.8,{height:this.$refs.body.scrollHeight+"px",ease:Expo.easeOut,onUpdate:this.onUpdate,onComplete:this.openComplete});
				}
				else
				{
					this.openComplete();
				}
			},

			onUpdate()
			{
				if(window.smoothScroll)
				{
					window.smoothScroll.update();
				}
			},

			openComplete()
			{
				TweenLite.set(this.$refs.body,{overflow:"visible",height:"auto",display:"block"});

				if(window.smoothScroll)
				{
					Vue.nextTick(() => {
						window.smoothScroll.update();
					});
				}
			},

			close()
			{
				this.active = false;

				const tween = !this.prefersReducedMotion;

				if(tween)
				{
					TweenLite.killTweensOf(this.$refs.body);
					TweenLite.set(this.$refs.body,{overflow:"hidden",display:"block",height:this.$refs.body.scrollHeight+"px"});
					TweenLite.to(this.$refs.body,.8,{height:0+"px",ease:Expo.easeOut,onUpdate:this.onUpdate,onComplete:this.closeComplete});
				}
				else
				{
					this.closeComplete();
				}
			},

			closeComplete()
			{
				TweenLite.set(this.$refs.body,{overflow:"hidden",height:0,display:"none"});

				if(window.smoothScroll)
				{
					Vue.nextTick(() => {
						window.smoothScroll.update();
					});
				}
			},

			handleHistoryChange () {
				if (window.location.hash == '#'+this.$refs.item.getAttribute("data-id")) {
					this.open(false);

					let margin = 60;
					TweenLite.to(window, .8, {scrollTo:{y:this.$refs.item,offsetY:margin,autoKill: false},delay:.01,ease:Expo.easeOut});
				}
			}
		},

		mounted () {
			this.$refs.item.classList.remove("vue-initialize");
			this.active = this.$refs.item.classList.contains("active");

			if(this.active)
				this.openComplete();

			//handle url hash parameter to open from outside
			this.handleHistoryChange();
			window.addEventListener('popstate', this.handleHistoryChange);
		},
		destroyed () {
			window.removeEventListener('popstate', this.handleHistoryChange);
		}
	});
});
